jQuery(document).ready(function(){
  jQuery('.six-column-mobile').slick({
  	autoplay: true,
  	autoplaySpeed: 3000,
  	arrows: true,
  	dots: true,
  	mobileFirst: true
  });
});

 jQuery(document).ready(function(){
    jQuery("#sticker").sticky({topSpacing:60});
    
    if (typeof SocialShareKit == 'function') {
     //Social Sharing
       SocialShareKit.init({
           reinitialize: true,
           url: window.location.href,
           twitter: {
               title: document.title,
               via: 'CCA'
           },
           onBeforeOpen: function(targetElement, network, paramsObj){
               console.log(arguments);
           },
           onOpen: function(targetElement, network, url, popupWindow){
               console.log(arguments);
           },
           onClose: function(targetElement, network, url, popupWindow){
               console.log(arguments);
           }
       });
   
       jQuery(function () {
   
           // Sticky icons changer
           jQuery('.sticky-changer').click(function (e) {
               e.preventDefault();
               var jQuerylink = jQuery(this);
               jQuery('.ssk-sticky').removeClass(jQuerylink.parent().children().map(function () {
                   return jQuery(this).data('cls');
               }).get().join(' ')).addClass(jQuerylink.data('cls'));
               jQuerylink.parent().find('.active').removeClass('active');
               jQuerylink.addClass('active').blur();
           });
       });
   
       // This code is required if you want to use Twitter callbacks
       window.twttr = (function (d, s, id) {
           var js, fjs = d.getElementsByTagName(s)[0],
                   t = window.twttr || {};
           if (d.getElementById(id)) return;
           js = d.createElement(s);
           js.id = id;
           js.src = "https://platform.twitter.com/widgets.js";
           fjs.parentNode.insertBefore(js, fjs);
   
           t._e = [];
           t.ready = function (f) {
               t._e.push(f);
           };
   
           return t;
       }(document, "script", "twitter-wjs"));
   
       // Demo callback
       function twitterDemoCallback(e) {
           jQuery('#twitterEvents').append(e.type + ' ');
       }
   
       // Bind to Twitter events
       twttr.ready(function (tw) {
           tw.events.bind('click', twitterDemoCallback);
           tw.events.bind('tweet', twitterDemoCallback);
       }); 
    }
  });


// Gravity Forms

jQuery(document).ready(function(){
   jQuery('.ginput_container_textarea').parent().addClass('textarea-clear');
   jQuery('.ginput_container_fileupload').parent().addClass('textarea-clear');
});
  